import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { MessageLayout, CloseIconFrame, InformationFrame, InfoMsg, ActionItem, PopUpTitle, } from './styles';
import { useStyles } from './styles';
import Icon from '../../utils/icons';


const CustomQrPopup = (props) => {
    const classes = useStyles();
    return (
        <div>
            <CloseIconFrame>
                <div>
                    <div className={classes.qrCodeHeading}></div>
                    {props.title && <PopUpTitle>{props.title}</PopUpTitle>}
                </div>
                <div>
                    {props.dismiss && <CloseIcon onClick={props.leftAction} className={classes.closeIcon}  />}
                </div>
            </CloseIconFrame>  
            <MessageLayout> 
                <InformationFrame>
                {props.icon && <div class="img-container">
                    <Icon src="airDeviceQR" />
                </div>
              }
                </InformationFrame>
            </MessageLayout> 
                <ActionItem>
                    <div onClick={props.rightAction}>
                        <span >{props.rightButtonText}</span>
                    </div>
            </ActionItem>
        </div>
    )
}
export default CustomQrPopup